import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { StarRating } from 'src/common/starRating';
import { TruncatedParagraph } from 'src/common/styled';
// TODO: Format review count number with commas
export const ProductTitleBlock = ({ title, reviews }) => {
    const onReviewsClick = () => {
        const element = document.getElementById('reviews-histogram');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (_jsxs(Column, { spacingInset: "350 350 none 350", spacing: "300", "data-testid": "product-title", children: [_jsx("div", { onClick: onReviewsClick, children: !!reviews && (_jsxs(Row, { alignmentHorizontal: "end", spacing: "200", "data-testid": "star-rating-container", children: [_jsx(Text, { type: "b100", "data-testid": "rating", children: reviews.rating || 0 }), _jsx(StarRating, { rating: (reviews === null || reviews === void 0 ? void 0 : reviews.rating) || 0 }), _jsxs(Text, { type: "b100", "data-testid": "star-rating-number", children: ["(", (reviews === null || reviews === void 0 ? void 0 : reviews.count) || 0, ")"] })] })) }), _jsx(TruncatedParagraph, { clamp: 3, type: "b200", children: title })] }));
};
